<div class="chart-container" style="display: block;">
  <ngx-charts-bar-vertical-stacked
    [results]="chartData"
    [scheme]="colorScheme"
    [customColors]="customColors"
    [view]="viewsize"
    [legend]="showLegend"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [xAxisTickFormatting]="formatQuestionLabel">
  </ngx-charts-bar-vertical-stacked>
  <div *ngIf="loading" class="loading">Loading…</div>
  <div *ngIf="errorMsg" class="error">{{ errorMsg }}</div>
</div>
